<template>
  <div class="top-margin">
    <div uk-slideshow="animation: slide;
    autoplay: true;
    autoplay-interval: 5000;">
      <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1">
        <div>
          <ul class="uk-slideshow-items">
            <li v-for="(item,index) in content" :key="item.id" class="add-pointer">
              <img :id="'mrktImg'+(index+1)" :src="item.path" :alt="item.description" @click="openLink(item)" uk-img>
            </li>
          </ul>
        </div>
        <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous
           uk-slideshow-item="previous"></a>
        <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next
           uk-slideshow-item="next"></a>
        <div class="uk-overlay uk-position-bottom">
          <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-flex-middle uk-margin"></ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {ENGLISH_US, GERMAN, SWEDISH} from '../../../enums/marketing-content'
    import {MARKETING} from '../../../enums/localization-image-types'
    import mixpanel from '../../../services/mixpanel'
    import * as event from '../../../enums/mixpanel-event'
    import fileUtil from '../../../utils/file-util'
    import * as url from '../../../enums/static-urls'

    export default {
      name: 'marketing-carousel',
      methods: {
        openLink(item) {
          this.mixpanelEvent(item)
          window.open(item.link, item.target)
        },
        mixpanelEvent(item) {
          mixpanel.track(event.MARKETING_CLICKED, {target: item.link})
        }
      },
      computed: {
        content() {
          switch (this.$i18n.locale) {
            case 'en-US':
              return ENGLISH_US
            case 'de':
              return GERMAN
            case 'sv':
              return SWEDISH
            default:
              return [{
                path: fileUtil.localeAssetPath(this.$i18n.locale, MARKETING),
                link: url.SMEX_LEARN_MORE_VIDEO,
                target: '_blank'
              }]
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';
  .top-margin {
    margin-top: 20px
  }

  img {
    width: 100%;
    height: 100%;
  }
</style>
